import { HttpClient } from "../../services/api/httpclient.service";
import axios, { AxiosError } from "axios";

export class LoginService extends HttpClient {
  constructor() {
    super();
  }

  public async login(email: string, password: string, expected_user_type?: string) {
    try {
      const response = await this.post("/auth/login", { email, password, expected_user_type }, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return {
        success: true,
        user: response.user,
        gamification_state: response.gamification_state,
      };
    } catch (error: any) {
      console.error("Login service error:", error);
  
      const axiosError = error as AxiosError;
      const status = axiosError.response?.status || error.status;
  
      if (status === 422) {
        throw {
          success: false,
          code: "invalid_credentials",
        };
      } else if (status === 403) {
        throw {
          success: false,
          code: "unauthorized",
        };
      } else if (status === 503) {
        throw {
          success: false,
          code: "server_unavailable",
        };
      }
  
      throw {
        success: false,
        code: "login_failed",
      };
    }
  }
  
  public async handleServerLogout() {
    try {
      await this.post("/auth/logout", {}, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return {
        success: true
      };
    } catch (error) {
      console.error("Logout service error:", error);
      return {
        success: false,
        message: "Failed to logout"
      };
    }
  }


  async requestOtp(email: string, first_name: string, mode: string): Promise<void> {
    try {
      await this.post("/auth/request-otp", { email, first_name, mode }, {
        headers: {
          "Content-Type": "application/json",
        }, 
      });
    } catch (error: any) {
      error.customMessage =
        error?.response?.data?.detail?.message ||
        error?.response?.data?.detail ||
        "Failed to request OTP";
      throw error;
    }
  }

  async verifyOtp(
    email: string,
    otp: string,
    first_name: string,
    last_name: string,
    user_type: number,
    password: string
  ): Promise<any> {
    try {
      const response = await this.post(
        "/auth/verify-otp",
        { email, otp, first_name, last_name, user_type, password },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return {
        ...response,
        success: true
      };
    } catch (error: any) {
      error.customMessage =
        error?.response?.data?.detail?.message ||
        error?.response?.data?.detail ||
        "OTP verification failed";
      throw error;
    }
  }



  async verifyResetPasswordOtp(email: string, otp: string): Promise<any> {
    try {
      return await this.post("/auth/reset-password-verify", { email, otp });
    } catch (error: any) {
      error.customMessage =
        error?.response?.data?.detail?.message ||
        error?.response?.data?.detail ||
        "OTP verification failed";
      throw error;
    }
  }

  async updatePassword(password: string): Promise<any> {
    try {
      return await this.post("/auth/reset-password", { password });
    } catch (error: any) {
      error.customMessage =
        error?.response?.data?.detail?.message ||
        error?.response?.data?.detail ||
        "Password update failed";
      throw error;
    }
  }

  async emailValidation(
    email: string,
    password?: string,
    mode: 'register' | 'reset' = 'register'
  ): Promise<any> {
    try {
      return await this.post("/auth/email-validation", { email, password, mode });
    } catch (error: any) {
      error.customMessage =
        error?.response?.data?.detail?.message ||
        error?.response?.data?.detail ||
        "Email validation failed";
      throw error;
    }
  }
  
}

